import { WidgetConfig } from '@loctypes'
import { ConfigValues } from './types'

export const pulloutValues = (config: WidgetConfig): ConfigValues => {
  const { schemas, modules } = config
  const { themeId, pager } = modules.chat.corner

  return {
    themeId,
    colors: schemas.colors,
    backgroundType: pager.background.type,
    gradientId: pager.background.gradientId,
    enableWelcomePage: pager.mainPage.welcomeWidget.enable
  }
}
